// import appLogo from "./images/app-logo.png"
import appLogo from './images/app-logo-2.png'
import userAvatar from './images/user-avtar.webp'
import trophy from './images/trophy.svg'
import certificate from './images/certificate.png'
import pureTouchLogo from './images/app-logo-2.png'
import placeHolderImg from './images/placeholder.png'

export const images = {
    appLogo,
    userAvatar,
    trophy,
    certificate,
    pureTouchLogo,
    placeHolderImg
}